import { useState, useEffect } from "react";
import TextInput from "@components/TextInput/TextInput";
import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import SearchIcon from "@assets/icons/outline/search.svg?react";
import XIcon from '@assets/icons/outline/x.svg?react';
import styles from "./SearchFilter.module.scss";

const SearchFilter = ({ onChange, initialValue, multi, multiOrName, placeholder }: {
  onChange: (value: string[], rv?: string[]) => void,
  initialValue: string,
  placeholder?: string,
  multi?: boolean,
  multiOrName?: boolean,
  asPanel?: boolean,
}) => {
  const [text, setText] = useState<string>("");

  useEffect(() => {
    if (initialValue) {
      handleSearch(initialValue);
    }
  }, [initialValue])

  const handleSearch = (rawValue: string) => {
    let value = rawValue.trim();
    let requestValue: string | string[] = "";
    if (multiOrName) {
      if (value.search(/[^0-9\s,]/) === -1) {
        value = value.replace(/\s+/g, " ");
        requestValue = value.replace(/,?\s+/g, ",").split(",");
      } else {
        requestValue = [value];
      }
    }
    if (multi) {
      value = value.replace(/\s+/g, " ");
      requestValue = value.replace(/,?\s+/g, ",");
    }
    setText(value);
    const rValue = Array.isArray(requestValue) ? requestValue : (
      requestValue ? [requestValue] : undefined
    )
    onChange([value], rValue);
  };

  const onSearch = () => handleSearch(text)

  return (
    <TextInput
      className={styles.input}
      placeholder={placeholder}
      type="text"
      value={text}
      onChange={setText}
      onBlur={onSearch}
      onKeyDown={(e: any) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onSearch();
        }
      }}
      prefix={<SearchIcon onClick={onSearch} className={styles.searchIcon} />}
      suffix={
        <IconButton
          icon={XIcon}
          onClick={() => {
            // e.preventDefault();
            // e.stopPropagation();
            setText("");
            handleSearch("");
          }}
          size={IconButtonSize.L}
          type={IconButtonType.ICON}
        />
      }
      // autoFocus
    />
  );
}

export default SearchFilter;
